import { defaultSubcategories, defaultCategories, defaultModules, defaultForm, defaultFilterForms } from "./state";

/**
 * Mutación que establece los módulos.
 *
 * @param {*} state.modules - El estado de los módulos.
 * @returns {void}
 * @author Brandon Torres
 */
export function setModules(state, modules) {
    state.modules = modules;
}

/**
 * Mutación que establece las categorías.
 *
 * @param {*} state.categories - El estado de las categorías.
 * @returns {void}
 * @author Brandon Torres
 */
export function setCategories(state, categories) {
    state.categories = categories;
}

/**
 * Mutación que establece las subcategorías.
 *
 * @param {*} state.subcategories - El estado de las subcategorías.
 * @returns {void}
 * @author Brandon Torres
 */
export function setSubcategories(state, subcategories) {
    state.subcategories = subcategories;
}

/**
 * Mutación que establece los valores por defecto de las subcategorías.
 *
 * @param {*} state.subcategories - El estado de las subcategorías.
 * @returns {void}
 * @author Brandon Torres
 */
export function setDefaultSubcategories(state) {
    state.subcategories = defaultSubcategories();
}

/**
 * Mutación que establece los valores por defecto de las categorías.
 *
 * @param {*} state.categories - El estado de las categorías.
 * @returns {void}
 * @author Brandon Torres
 */
export function setDefaultCategories(state) {
    state.categories = defaultCategories();
}

/**
 * Mutación que establece los valores por defecto de los módulos.
 *
 * @param {*} state.modules - El estado de los módulos.
 * @returns {void}
 * @author Brandon Torres
 */
export function setdefaultModules(state) {
    state.modules = defaultModules();
}

/**
 * Mutación que establece los valores por defecto del formulario.
 *
 * @param {*} state.form - El estado del formulario.
 * @returns {void}
 * @author Brandon Torres
 */
export function setDefaultForm(state) {
    state.form = defaultForm();
}

/**
 * Mutación que establece los formularios.
 *
 * @param {*} state.formBuilders - El estado de los formularios.
 * @returns {void}
 * @author Brandon Torres
 */
export function setFormBuilders(state, formBuilders) {
    state.formBuilders = formBuilders;
}

/**
 * Mutación que establece el filtro de formularios por defecto.
 *
 * @param {*} state.filterForms - Estado del filtro de formularios.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterForms(state) {
    state.filterForms = defaultFilterForms();
}

/**
 * Mutación que establece la cantidad de formularios por página.
 *
 * @param per_page - Cambio de cantidad de registros por página.
 * @param {*} state.filterForms.per_page - Cantidad de registros por página.
 * @param {*} state.filterForms.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterForms = {
        ...state.filterForms,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param page - Cambio de página actual.
 * @param {*} state.filterForms.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterForms.page = page;
}

/**
 * Mutación que establece el paginador de registros de formularios.
 *
 * @param paginate - Paginación de registros.
 * @param {*} state.filterForms.page - Página actual.
 * @param {*} state.filterForms.per_page - Cantidad de registros por página.
 * @param {*} state.filterForms.total - Total de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateForms(state, paginate) {
    state.filterForms = {
        ...state.filterForms,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece el formulario dinámico.
 *
 * @param {*} state.form - El estado del formulario.
 * @param formBuilder - Datos del formulario dinámico.
 * @return {void}
 * @author Brandon Torres
 */
export function setFormBuilder(state, formBuilder) {
    state.form = formBuilder;
}

/**
* Mutación que establece las categorías por nombre del módulo.
*
* @param {*} state.categoriesForModule - El estado de las categorías por módulo.
* @param categoriesForModule - Datos de las categorías por módulo.
* @return {void}
* @author Brandon Torres
*/
export function setCategoriesForModule(state, categoriesForModule) {
    state.categoriesForModule = categoriesForModule;
}

/**
 * Mutación que establece el formulario por categoría.
 *
 * @param {*} state.formByCategory - El estado del formulario por categoría.
 * @param formByCategory - Datos del formulario por categoría.
 * @return {void}
 * @author Brandon Torres
 */
export function setFormByCategory(state, formByCategory) {
    state.formByCategory = formByCategory || { components: [] };
}

/**
 * Mutación que establece los listados de EPPs.
 *
 * @param {*} state.submissionsEpps - El estado de los listados de EPPs.
 * @param submissionsEpps - Datos de los listados de EPPs.
 * @return {void}
 * @autor Brandon Torres
 */
export function setSubmissionsEpps(state, submissionsEpps) {
    state.submissionsEpps = submissionsEpps;
}
